<div class="menuWeb">


  <mdb-navbar SideClass="navbar  navbar-expand-lg navbar-light navradios white fixed-top "
    style="border-radius: 10px !important;" [containerInside]="false">

    <mdb-navbar-brand>
      <links>


        <ul class="navbar-nav mr-auto">

          <li class="nav-item dropdown " dropdown>
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link waves-light" mdbWavesEffect>
              <img style="margin-top:1rem;margin-left: 2.5rem;" width="30px"
                src="assets/images/general/LINEAS_MENU.jpg">
            </a>
            <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary divMenuDes" role="menu">
              <a class="nav-link waves-light" [routerLink]="['home/presentacion']">ACERCA DE MEMORIA PERÚ</a>
              <a class="nav-link waves-light" [routerLink]="['/','temas']">TEMAS</a>
              <a class="nav-link waves-light" [routerLink]="['/','recorridos']">RECORRIDOS</a>
              <a class="nav-link waves-light" [routerLink]="['/','documentos']">DOCUMENTOS DESTACADOS</a>
              <a class="nav-link waves-light" [routerLink]="['/','contacto']">CONTACTO</a>


            </div>
          </li>
        </ul>
      </links>
    </mdb-navbar-brand>

    <mdb-navbar-brand>
      <a class="nav-link waves-light" [routerLink]="['/']">
        <img src="assets/images/general/LOGOMARCA_COMPLETA_MP_COLOR.png" class="rounded float-left logoHeader">
      </a>
      <a class="nav-link waves-light" [routerLink]="['/']">
        <img src="assets/images/general/LOGO_MP.jpg" class="rounded float-left logoHeaderMovil">
      </a>
    </mdb-navbar-brand>
    <links class="menuMovilD">
      <ul class="navbar-nav ml-auto ">
        <!-- Dropdown -->
        <li class="nav-item">
          <a class="nav-link waves-light" [routerLink]="['/']">INICIO</a>
        </li>
        <li class="nav-item">
          <a class="nav-link waves-light" [routerLink]="['/','recorridos']">&nbsp; | &nbsp; RECORRIDOS&nbsp; |
            &nbsp;</a>
        </li>
        <li class="nav-item">
          <a class="nav-link waves-light" [routerLink]="['/','contacto']">CONTACTO &nbsp;&nbsp;</a>
        </li>
        <li class="nav-item">

        </li>
      </ul>
    </links>
  </mdb-navbar>
</div>
<div class="menuMovilD">
  <mdb-navbar SideClass="navbar  navbar-expand-lg navbar-light navradios white fixed-top "
    style="border-radius: 10px !important;" [containerInside]="false">

    <mdb-navbar-brand>
      <links>


        <ul class="navbar-nav mr-auto">

          <li class="nav-item dropdown " dropdown>
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link waves-light" mdbWavesEffect>
              <img style="margin-top:1rem;margin-left: 2.5rem;" width="30px"
                src="assets/images/general/LINEAS_MENU.jpg">
            </a>
            <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary divMenuDes" role="menu">
              <a class="nav-link waves-light" [routerLink]="['/']">INICIO</a>
              <a class="nav-link waves-light" [routerLink]="['home/presentacion']">ACERCA DE MEMORIA PERÚ</a>
              <a class="nav-link waves-light" [routerLink]="['/','temas']">TEMAS</a>
              <a class="nav-link waves-light" [routerLink]="['/','recorridos']">RECORRIDOS</a>
              <a class="nav-link waves-light" [routerLink]="['/','documentos']">DOCUMENTOS DESTACADOS</a>
              <a class="nav-link waves-light" [routerLink]="['/','contacto']">CONTACTO</a>


            </div>
          </li>
        </ul>
      </links>
    </mdb-navbar-brand>

    <mdb-navbar-brand><img src="assets/images/general/LOGOMARCA_COMPLETA_MP_COLOR.png"
        class="rounded float-left logoHeader">
      <img src="assets/images/general/LOGO_MP.jpg" class="rounded float-left logoHeaderMovil">
    </mdb-navbar-brand>

  </mdb-navbar>


</div>